<template>
  <div class="dyk-page">
    <header class="dyk-hero">
      <div class="dyk-hero-glow" aria-hidden="true"></div>
      <span class="dyk-icon">💡</span>
      <h1>دانستنی‌های فوتبالی</h1>
      <p class="dyk-sub">
        هر روز یک مطلب کامل با عکس، جزئیات و منبع اصلی؛ رکوردهای عجیب،
        تاریخ فوتبال و روایت‌های کمترشنیده. مطالب گذشته در بایگانی کنار صفحه هستند.
      </p>
      <div class="dyk-meta">
        <span class="meta-pill">{{ faNo(facts.length) }} مطلب در بایگانی</span>
        <span class="meta-pill">📅 روزی یک دانستنی کامل</span>
        <span class="meta-pill">منبع لینک‌دار</span>
      </div>
    </header>

    <div class="dyk-layout">
      <!-- ستون اصلی: دانستنیِ امروز -->
      <div class="dyk-main">
        <article v-if="todayFact" class="fact-today">
          <div class="today-badge">⭐ دانستنیِ امروز</div>

          <figure v-if="todayFact.imageUrl" class="fact-photo">
            <img
                :src="todayFact.imageUrl"
                :alt="todayFact.imageAlt || todayFact.title"
                loading="lazy"
            >
            <span v-if="todayFact.category" class="fact-cat on-photo">{{ todayFact.category }}</span>
          </figure>

          <div class="fact-head">
            <span v-if="!todayFact.imageUrl && todayFact.category" class="fact-cat">{{ todayFact.category }}</span>
            <span v-if="todayFact.source && todayFact.source.name" class="fact-source">منبع: {{ todayFact.source.name }}</span>
          </div>

          <h2 class="today-title">
            <router-link :to="factLink(todayFact.slug)">{{ todayFact.title }}</router-link>
          </h2>

          <div class="today-body">
            <div class="today-text">
              <p
                  v-for="(p, j) in todayTeaser"
                  :key="j"
              >{{ p }}</p>
              <router-link :to="factLink(todayFact.slug)" class="today-more">
                ادامهٔ مطلب و متن کامل ←
              </router-link>
            </div>
            <!-- جعبهٔ عدد کلیدی -->
            <div
                v-if="todayFact.keyFigure"
                class="fact-figure"
                aria-hidden="true"
            >
              <span class="figure-num">{{ todayFact.keyFigure }}</span>
              <span class="figure-label">{{ todayFact.figureLabel }}</span>
            </div>
          </div>
        </article>

        <div v-else class="fact-today fact-today-empty">
          <div class="today-badge">⭐ دانستنیِ امروز</div>
          <p class="empty-note">
            اولین دانستنیِ امروز به‌زودی منتشر می‌شود — تا آن زمان
            بایگانی مطالب را از سایدبار کنار صفحه ببینید.
          </p>
        </div>

        <!-- منابع و مراجع -->
        <section v-if="sourceFacts.length" class="dyk-sources">
          <h2>منابع و مراجع</h2>
          <p class="sources-hint">لینک منبع هر مطلب، به ترتیب انتشار:</p>
          <ol>
            <li
                v-for="f in sourceFacts"
                :key="f.slug"
            >
              <span class="src-title">{{ f.title }}</span>
              <span class="src-sep">—</span>
              <a
                  v-if="f.source && f.source.url"
                  class="src-link"
                  :href="f.source.url"
                  target="_blank"
                  rel="noopener"
              >{{ f.source.name || 'منبع' }} ↗</a>
            </li>
          </ol>
        </section>

        <div class="dyk-links">
          <h2>ادامهٔ سرگردانی:</h2>
          <router-link
              to="/news"
              class="dyk-link"
          >📰 آخرین اخبار فوتبال</router-link>
          <router-link
              to="/compare"
              class="dyk-link"
          >⚖️ مقایسه دو تیم</router-link>
          <router-link
              to="/Matches"
              class="dyk-link"
          >⚽ برنامه و نتایج مسابقات</router-link>
        </div>
      </div>

      <!-- سایدبار: بایگانی مطالب گذشته -->
      <FactArchive
          class="dyk-aside"
          :facts="archiveFacts"
      />
    </div>
  </div>
</template>

<script>
import { setSeo } from '@/utils/seo'
import { footballFacts } from '@/data/footballFacts'
import api from '@/services/api'
import FactArchive from '@/components/FactArchive.vue'

export default {
  name: 'DidYouKnow',

  components: { FactArchive },

  data() {
    return {
      // نمایش فوری با بستهٔ استاتیک؛ اگر API جواب داد با فکت‌های دیتابیس
      // جایگزین می‌شود (پنل ادمین + خط لولهٔ «دانستنیِ روز»)
      facts: footballFacts,
    }
  },

  computed: {
    // دانستنیِ امروز = featuredAt در روزِ جاری تهران؛ فالبک: جدیدترین منتشرشده
    todayFact() {
      if (!this.facts.length) return null
      const todayKey = this.dayKey(new Date())
      const featured = this.facts.find((f) => f.featuredAt && this.dayKey(f.featuredAt) === todayKey)
      if (featured) return featured
      return this.facts.slice().sort((a, b) => this.ts(b) - this.ts(a))[0]
    },

    // تیزر امروز: دو پاراگراف اول (متن کامل روی صفحهٔ اختصاصی)
    todayTeaser() {
      return (this.todayFact && this.todayFact.paragraphs || []).slice(0, 2)
    },

    // بایگانی: همه به‌جز دانستنیِ امروز — جدیدترین اول
    archiveFacts() {
      if (!this.todayFact) return this.sortedFacts()
      return this.sortedFacts().filter((f) => f.slug !== this.todayFact.slug)
    },

    sourceFacts() {
      return this.facts.filter((f) => f.source && f.source.url).slice(0, 40)
    },
  },

  created() {
    setSeo({
      title: 'دانستنی‌های فوتبالی | ضربه آزاد',
      description: 'دانستنیِ روز فوتبال — هر روز یک مطلب کامل با عکس و منبع اصلی؛ رکوردها، تاریخ فوتبال و روایت‌های کمترشنیده در ضربه آزاد',
      path: '/did-you-know',
    })
    this.loadFacts()
  },

  methods: {
    // فکت‌ها از دیتابیس (پنل ادمین + خط لولهٔ خودکار)؛ هر خطا = بستهٔ استاتیک
    async loadFacts() {
      try {
        const list = await api.getFacts()
        if (Array.isArray(list) && list.length) {
          this.facts = list
        }
      } catch {
        /* بستهٔ استاتیک می‌ماند */
      }
    },

    factLink(slug) {
      return '/did-you-know/' + encodeURIComponent(slug)
    },

    // کلید روز به وقت تهران — «YYYY-MM-DD»
    dayKey(d) {
      try {
        return new Date(d).toLocaleDateString('en-CA', { timeZone: 'Asia/Tehran' })
      } catch {
        return new Date(d).toISOString().slice(0, 10)
      }
    },

    ts(f) {
      return new Date(f.featuredAt || f.publishedAt || 0).getTime()
    },

    sortedFacts() {
      return this.facts.slice().sort((a, b) => this.ts(b) - this.ts(a))
    },

    faNo(n) {
      return String(n)
          .replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d])
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/sass/variables';
@import '@/assets/sass/mixin';

.dyk-page {
  margin: 0 auto;
  padding: 24px 12px 48px;
}

// ---------- هیرو ----------
.dyk-hero {
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 44px 20px 30px;
  border-radius: 22px;
  background: linear-gradient(150deg, #064e3b 0%, #065f46 55%, #022c22 100%);
  color: #fff;
  margin-bottom: 8px;

  .dyk-hero-glow {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(320px 180px at 85% 0%, rgba(74, 222, 128, .28), transparent 70%),
      radial-gradient(260px 160px at 8% 100%, rgba(248, 113, 113, .18), transparent 70%);
    pointer-events: none;
  }

  .dyk-icon {
    font-size: 50px;
    display: inline-block;
    margin-bottom: 10px;
    position: relative;
  }

  h1 {
    margin: 0 0 10px;
    font-size: 28px;
    color: #fff;
    position: relative;
  }
}

.dyk-sub {
  color: rgba(255, 255, 255, .82);
  font-size: 15px;
  margin: 0 auto;
  max-width: 560px;
  line-height: 1.95;
  position: relative;
}

.dyk-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
  position: relative;
}

.meta-pill {
  background: rgba(255, 255, 255, .12);
  border: 1px solid rgba(255, 255, 255, .25);
  color: #fff;
  font-size: 12.5px;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 999px;
  backdrop-filter: blur(4px);
}

// ---------- چیدمان دوستونی: امروز + بایگانی ----------
.dyk-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 20px;
  align-items: start;
  margin-top: 20px;
}

.dyk-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dyk-aside {
  min-width: 0;
}

// ---------- کارت دانستنیِ امروز ----------
.fact-today {
  position: relative;
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 18px;
  padding: 22px;
  box-shadow: $shadow-sm;

  &-empty .empty-note {
    color: #6b7280;
    font-size: 14px;
    line-height: 2;
    margin: 8px 0 0;
  }
}

.today-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #d97706, #f59e0b);
  color: #fff;
  font-weight: 800;
  font-size: 12.5px;
  padding: 5px 14px;
  border-radius: 999px;
  margin-bottom: 14px;
  box-shadow: 0 4px 12px rgba(217, 119, 6, .3);
}

.fact-photo {
  margin: 0 0 16px;
  position: relative;
  overflow: hidden;
  border-radius: 14px;

  img {
    display: block;
    width: 100%;
    max-height: 380px;
    object-fit: cover;
    transition: transform .45s ease;
  }

  &:hover img { transform: scale(1.025); }
}

.fact-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.fact-cat {
  display: inline-block;
  background: linear-gradient(135deg, #047857, #10b981);
  color: #fff;
  font-weight: 700;
  font-size: 12.5px;
  padding: 5px 14px;
  border-radius: 999px;

  &.on-photo {
    position: absolute;
    bottom: 12px;
    right: 14px;
    background: rgba(2, 44, 34, .82);
    backdrop-filter: blur(4px);
  }
}

.fact-source {
  color: #6b7280;
  font-size: 12.5px;
  font-weight: 600;
}

.today-title {
  margin: 0 0 12px;
  font-size: 20px;
  line-height: 1.7;
  color: #111827;

  a {
    color: inherit;
    text-decoration: none;

    &:hover { color: #047857; }
  }
}

.today-body {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

.today-text {
  flex: 1;
  min-width: 0;

  p {
    margin: 0 0 10px;
    color: #374151;
    font-size: 14.5px;
    line-height: 2.05;
    text-align: justify;
  }
}

.today-more {
  display: inline-block;
  color: #047857;
  font-weight: 800;
  font-size: 13.5px;
  text-decoration: none;
  margin-top: 2px;

  &:hover { color: #065f46; text-decoration: underline; }
}

.fact-figure {
  flex-shrink: 0;
  width: 112px;
  min-height: 96px;
  border-radius: 14px;
  background: linear-gradient(160deg, #fef2f2, #fff7ed);
  border: 1px solid #fecaca;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 6px;

  .figure-num {
    font-size: 27px;
    font-weight: 900;
    color: $red;
    line-height: 1.15;
    text-align: center;
  }

  .figure-label {
    font-size: 11.5px;
    font-weight: 700;
    color: #6b7280;
    text-align: center;
  }
}

// ---------- منابع (پایین ستون) ----------
.dyk-sources {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 16px;
  padding: 20px 22px;
  box-shadow: $shadow-sm;

  h2 {
    margin: 0 0 6px;
    font-size: 16px;
    color: #111827;
  }
}

.sources-hint {
  margin: 0 0 12px;
  color: #9ca3af;
  font-size: 12.5px;
}

.dyk-sources ol {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: src;

  li {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    padding: 9px 0;
    border-bottom: 1px dashed $gray-200;

    &:last-child { border-bottom: none; }
  }
}

.src-title {
  color: #374151;
  font-size: 13.5px;
  font-weight: 700;
}

.src-sep { color: $gray-300; }

.src-link {
  color: #3b82f6;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
    color: #1e3a8a;
  }
}

// ---------- لینک‌های سرگردانی ----------
.dyk-links {
  background: #fff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: $shadow-sm;

  h2 {
    margin: 0 0 12px;
    font-size: 15px;
    color: #111827;
  }
}

.dyk-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  color: #1e3a8a;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  transition: background .15s;

  &:hover { background: $gray-50; }
}

// ---------- رسپانسیو ----------
@media (max-width: 1024px) {
  .dyk-layout {
    grid-template-columns: minmax(0, 1fr) 260px;
  }
}

@media (max-width: 768px) {
  .dyk-page {
    padding: 12px 8px 36px;
  }

  .dyk-hero {
    padding: 28px 14px 20px;
    border-radius: 16px;

    h1 { font-size: 22px; }
  }

  .dyk-sub { font-size: 13.5px; }

  // موبایل: بایگانی زیر مطلب امروز
  .dyk-layout {
    grid-template-columns: 1fr;
  }

  .dyk-aside {
    order: 2;
  }

  .fact-today {
    padding: 16px 14px;
    border-radius: 14px;
  }

  .fact-photo {
    img { max-height: 230px; }
  }

  .today-body {
    flex-direction: column-reverse;
    gap: 12px;
  }

  .fact-figure {
    width: 100%;
    min-height: 0;
    flex-direction: row;
    gap: 8px;
    padding: 8px 12px;

    .figure-num { font-size: 22px; }
  }

  .today-text {
    p { font-size: 13.5px; }
  }

  .dyk-sources {
    padding: 16px 14px;
  }

  .src-title { font-size: 12.5px; }
  .src-link { font-size: 12.5px; }
}
</style>
